export default [
    {
        path: 'game',
        name: 'create:game',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/SetGameSettings.vue'
            ),
        meta: {
            title: 'router.router_gameEdit',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props: true,
    },
    {
        path: 'games/settings',
        name: 'games:settings',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/SetGameSettings.vue'
            ),
        meta: {
            title: 'router.router_gameEdit',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props: true,
    },
    {
        path: 'trainer/games/AdditionAndSubtraction/:exerciseId?/play',
        name: 'addition-and-subtraction:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/addition-and-subtraction/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AdditionAndSubtraction',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Expressions/:exerciseId?/play',
        name: 'expressions:start',
        component: () => import('../../components/trainer/games/expressions/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Expressions',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/AdditionAndSubtractionMathMagic/:exerciseId?/play',
        name: 'addition-and-subtraction-math-magic:start',
        component: () => import('../../components/trainer/games/addition-and-subtraction-math-magic/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AdditionAndSubtractionMathMagic',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/sequence-of-numbers/:exerciseId?/play',
        name: 'sequence-of-numbers:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/sequence-of-numbers/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SequenceOfNumbers',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/FlashCards/:exerciseId?/play',
        name: 'flash-cards:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/flash-cards/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'FlashCards',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/InteractiveFlashCards/:exerciseId?/play',
        name: 'interactive-flash-cards:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/interactive-flash-cards/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'InteractiveFlashCards',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/AdditionAndSubtractionWithTime/:exerciseId?/play',
        name: 'addition-and-subtraction-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/addition-and-subtraction-with-time/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AdditionAndSubtractionWithTime',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/MultiplicationAndDivision/:exerciseId?/play',
        name: 'multiplication-and-division:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/multiplication-and-division/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'MultiplicationAndDivision',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/MultiplicationAndDivisionMathMagic/:exerciseId?/play',
        name: 'multiplication-and-division-math-magic:start',
        component: () => import('../../components/trainer/games/multiplication-and-division-math-magic/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'MultiplicationAndDivisionMathMagic',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/TabularMultiplication/:exerciseId?/play',
        name: 'tabular-multiplication:start',
        component: () => import('../../components/trainer/games/tabular-multiplication/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TabularMultiplication',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Equation/:exerciseId?/play',
        name: 'equation:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/equation/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Equation',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Factorization/:exerciseId?/play',
        name: 'factorization:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/factorization/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Factorization',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Alpari/:exerciseId?/play',
        name: 'alpari:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/alpari/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Alpari',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/EquationOnline/:exerciseId?/play',
        name: 'equation-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/equation-online/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'EquationOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Anzan/:exerciseId?/play',
        name: 'anzan:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anzan/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Anzan',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/AnzanWithTime/:exerciseId?/play',
        name: 'anzan-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anzan-with-time/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AnzanWithTime',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Chains/:exerciseId?/play',
        name: 'chains:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/chains/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Chains',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Chains/:exerciseId?/play',
        name: 'chains-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/chains/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Chains',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Couples/:exerciseId?/play',
        name: 'couples:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Couples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Shutter/:exerciseId?/play',
        name: 'shutter:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/shutter/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Shutter',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ShutterOnline/:exerciseId?/play',
        name: 'shutter-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/shutter/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ShutterOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Couples/:exerciseId?/play',
        name: 'couples-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Couples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/schulte/:exerciseId?/play',
        name: 'schulte:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/schulte/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Schulte',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/memorize/:exerciseId?/play',
        name: 'memorize:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/memorize/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Memorize',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/KeenEye/:exerciseId?/play',
        name: 'keen-eye:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/keen-eye/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'KeenEye',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/KeenEyeMemoryDevelopment/:exerciseId?/play',
        name: 'keen-eye-memory-development:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/keen-eye/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'KeenEye',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/KeenEye/:exerciseId?/play',
        name: 'keen-eye-bonus-games:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/keen-eye/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'KeenEyeBonusGames',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/NumericalNetwork/:exerciseId?/play',
        name: 'numerical-network:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/numerical-network/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'NumericalNetwork',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/assemble-the-number/:exerciseId?/play',
        name: 'assemble-the-number:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/assemble-the-number/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AssembleTheNumber',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsField/:exerciseId?/play',
        name: 'words-field:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/words-field/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsField',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsFieldOnline/:exerciseId?/play',
        name: 'words-field-online:start',
        component: () => import('../../components/trainer/games/words-field/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsFieldOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsFieldOnline/:exerciseId?/play',
        name: 'words-field-online-with-time:start',
        component: () => import('../../components/trainer/games/words-field/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsFieldOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsFieldWithTime/:exerciseId?/play',
        name: 'words-field-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/words-field/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsField',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/LettersField/:exerciseId?/play',
        name: 'letters-field:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/letters-field/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'LettersField',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/LettersFieldOnline/:exerciseId?/play',
        name: 'letters-field-online:start',
        component: () => import('../../components/trainer/games/letters-field/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'LettersFieldOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Scanner/:exerciseId?/play',
        name: 'scanner:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/scanner/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Scanner',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Scanner/:exerciseId?/play',
        name: 'scanner-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/scanner/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Scanner',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Anagrams/:exerciseId?/play',
        name: 'anagrams:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anagrams/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Anagrams',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Anagrams/:exerciseId?/play',
        name: 'anagrams-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anagrams/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Anagrams',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/AnagramsOnline/:exerciseId?/play',
        name: 'anagrams-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anagrams/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AnagramsOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/AnagramsOnline/:exerciseId?/play',
        name: 'anagrams-online-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/anagrams/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AnagramsOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Texts/:exerciseId?/play',
        name: 'texts:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/texts/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Texts',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/TextsOnline/:exerciseId?/play',
        name: 'texts-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/texts/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TextsOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/TextsOnline/:exerciseId?/play',
        name: 'texts-online-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/texts/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TextsOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Texts/:exerciseId?/play',
        name: 'texts-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/texts/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Texts',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CatchWord/:exerciseId?/play',
        name: 'catch-word:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/catch-word/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CatchWord',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CatchWordOnline/:exerciseId?/play',
        name: 'catch-word-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/catch-word/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CatchWordOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/VisionField/:exerciseId?/play',
        name: 'vision-field:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vision-field/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VisionField',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Matrix/:exerciseId?/play',
        name: 'matrix:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/matrix/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Matrix',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Matrix/:exerciseId?/play',
        name: 'matrix-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/matrix/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Matrix',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Navigator/:exerciseId?/play',
        name: 'navigator:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/navigator/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Navigator',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Synonyms/:exerciseId?/play',
        name: 'synonyms:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/synonyms/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Synonyms',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/SynonymsOnline/:exerciseId?/play',
        name: 'synonyms-online:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/synonyms/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SynonymsOnline',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Antonyms/:exerciseId?/play',
        name: 'antonyms:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/antonyms/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Antonyms',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Search/:exerciseId?/play',
        name: 'search:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/search/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Search',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Classifications/:exerciseId?/play',
        name: 'classifications:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/classifications/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Classifications',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Associations/:exerciseId?/play',
        name: 'associations:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/associations/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Associations',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/SoundCouples/:exerciseId?/play',
        name: 'sound-couples:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/sound-couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SoundCouples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/DigitCouples/:exerciseId?/play',
        name: 'digit-couples:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/digit-couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'DigitCouples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Presentations/:exerciseId?/play',
        name: 'presentations:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/trainer/games/presentations/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Presentations',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },

    {
        path: 'presentations/create',
        name: 'presentations:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/Create.vue'
            ),
        meta: {
            title: 'router.router_addPresentation',
            prev: {
                name: 'create:game',
                query: { slug: 'Presentations' },
            },
        },
        props($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'presentations',
            };
        },
    },
    {
        path: 'presentation/:id/edit',
        name: 'presentation:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/Create.vue'
            ),
        meta: {
            title: 'router.router_editPresentation',
            prev: {
                name: 'create:game',
                query: { slug: 'Presentations' },
            },
        },
        props($route) {
            return {
                id: $route.params.id,
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'presentations',
            };
        },
    },
    {
        path: 'education-material/create',
        name: 'education-material:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/Create.vue'
            ),
        meta: {
            title: 'router.router_addEducationMaterial',
            prev: {
                name: 'education-materials:main',
            },
        },
        props($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'education-material',
            };
        },
    },
    {
        path: 'education-material/:id/edit',
        name: 'education-material:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/Create.vue'
            ),
        meta: {
            title: 'router.router_editEducationMaterial',
            prev: {
                name: 'education-materials:main',
            },
        },
        props($route) {
            return {
                id: $route.params.id,
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'education-material',
            };
        },
    },
    {
        path: 'presentations-theme/create',
        name: 'presentations-theme:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/theme/Create.vue'
            ),
        meta: {
            title: 'router.router_addPresentationTheme',
            prev: {
                name: 'create:game',
                query: { slug: 'Presentations' },
            },
        },
        props($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
            };
        },
    },
    {
        path: 'presentations-theme/:id/edit',
        name: 'presentations-theme:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/theme/Create.vue'
            ),
        meta: {
            title: 'router.router_editPresentationTheme',
            prev: {
                name: 'create:game',
                query: { slug: 'Presentations' },
            },
        },
        props($route) {
            return {
                id: $route.params.id,
                copy: $route.params.copy,
                page: $route.query.page,
            };
        },
    },
    {
        path: 'education-materials-theme/create',
        name: 'education-materials-theme:create',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/theme/Create.vue'
            ),
        meta: {
            title: 'router.router_addEducationMaterialsTheme',
            prev: {
                name: 'education-materials:main',
            },
        },
        props($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
            };
        },
    },
    {
        path: 'education-materials-theme/:id/edit',
        name: 'education-materials-theme:edit',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "presentations" */ '../../components/presentation/theme/Create.vue'
            ),
        meta: {
            title: 'router.router_editEducationMaterialsTheme',
            prev: {
                name: 'education-materials:main',
            },
        },
        props($route) {
            return {
                id: $route.params.id,
                copy: $route.params.copy,
                page: $route.query.page,
            };
        },
    },
    {
        path: 'trainer/games/FourthOne/:exerciseId?/play',
        name: 'fourth-one:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/fourth-one/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'FourthOne',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Memory/:exerciseId?/play',
        name: 'memory:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/memory/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Memory',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Puzzle/:exerciseId?/play',
        name: 'puzzle:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/puzzle/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Puzzle',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/RootsAndDegrees/:exerciseId?/play',
        name: 'roots-and-degrees:start',
        component: () => import('../../components/trainer/games/roots-and-degrees/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'RootsAndDegrees',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/RootsAndSquares/:exerciseId?/play',
        name: 'roots-and-squares:start',
        component: () => import('../../components/trainer/games/roots-and-squares/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'RootsAndSquares',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/DayOfWeek/:exerciseId?/play',
        name: 'day-of-week:start',
        component: () => import('../../components/trainer/games/day-of-week/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'DayOfWeek',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Loner/:exerciseId?/play',
        name: 'loner:start',
        component: () => import('../../components/trainer/games/Loner/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Loner',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/LonerMemoryDevelopment/:exerciseId?/play',
        name: 'loner:start',
        component: () => import('../../components/trainer/games/Loner/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Loner',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/LonerBonusGames/:exerciseId?/play',
        name: 'loner-bonus-games:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/loner/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'LonerBonusGames',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/LettersSoundsSyllables/:exerciseId?/play',
        name: 'letters-sounds-syllables:start',
        component: () => import('../../components/trainer/games/letters-sounds-syllables/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'LettersSoundsSyllables',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/CouplesMemoryDevelopment/:exerciseId?/play',
        name: 'couples-memory-development:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Couples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CouplesMemoryDevelopment/:exerciseId?/play',
        name: 'couples-memory-development-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Couples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Memo/:exerciseId?/play',
        name: 'memo:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/memo/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Memo',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/MemoryX/:exerciseId?/play',
        name: 'memory-x:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/memory-x/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'MemoryX',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ChainsMemoryDevelopment/:exerciseId?/play',
        name: 'chains-memory-development:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/chains/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Chains',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/RevivedNumbers/:exerciseId?/play',
        name: 'revived-numbers:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/revived-numbers/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'RevivedNumbers',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WhoIsWho/:exerciseId?/play',
        name: 'who-is-who:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/who-is-who/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WhoIsWho',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WhoIsWho/:exerciseId?/play',
        name: 'who-is-who-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/who-is-who/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WhoIsWho',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/SecretsOfCicero/:exerciseId?/play',
        name: 'secrets-of-cicero:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/secrets-of-cicero/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SecretsOfCicero',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/VocabularyWords/:exerciseId?/play',
        name: 'vocabulary-words:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vocabulary-words/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VocabularyWords',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/NavigatorMemoryDevelopment/:exerciseId?/play',
        name: 'navigator-memory-development:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/navigator/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Navigator',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/VocabularyMemo/:exerciseId?/play',
        name: 'vocabulary-memo:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vocabulary-memo/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VocabularyMemo',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CosmoTour/:exerciseId?/play',
        name: 'cosmo-tour:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/cosmotour/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CosmoTour',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/bonus-games/MentalDrawing/:exerciseId?/play',
        name: 'mental-drawing:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/mental-drawing/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'MentalDrawing',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                prev: {
                    name: 'trainer:games',
                    certainForBreadcrumbs: true,
                },
            };
        },
    },
    {
        path: 'trainer/bonus-games/HandsUp/:exerciseId?/play',
        name: 'hands-up:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/hands-up/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'HandsUp',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/bonus-games/Chameleon/:exerciseId?/play',
        name: 'chameleon:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/chameleon/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'Chameleon',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/bonus-games/RepeatAfterMe/:exerciseId?/play',
        name: 'repeat-after-me:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/repeat-after-me/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'RepeatAfterMe',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/bonus-games/CorrectiveSamples/:exerciseId?//play',
        name: 'corrective-samples:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/corrective-samples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'CorrectiveSamples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CorrectiveSamplesWithTime/:exerciseId?/play',
        name: 'corrective-samples-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/corrective-samples/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CorrectiveSamples',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Memo/:exerciseId?/play',
        name: 'memo-bonus-games:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/memo/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'MemoBonusGames',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Navigator/:exerciseId?/play',
        name: 'navigator-bonus-games:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/navigator/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'NavigatorBonusGames',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ChainsBonusGame/:exerciseId?/play',
        name: 'chains-bonus-game:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/chains-bonus-game/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ChainsBonusGame',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ChainsBonusGame/:exerciseId?/play',
        name: 'chains-bonus-game-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/chains-bonus-game/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ChainsBonusGame',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/bonus-games/Scout/:exerciseId?/play',
        name: 'scout:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/games/bonus-games/scout/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'Scout',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/EquationMultiplication/:exerciseId?/play',
        name: 'equation-multiplication:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/equation-multiplication/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'EquationMultiplication',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Diada/:exerciseId?/play',
        name: 'diada:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/diada/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'trainer:games',
                certainForBreadcrumbs: true,
            },
        },
        props($route) {
            return {
                type: 'Diada',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Diada/:exerciseId?/play',
        name: 'diada-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/diada/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Diada',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ChainsReadingEn/:exerciseId?/play',
        name: 'chains-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/chains-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ChainsReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ChainsReadingEn/:exerciseId?/play',
        name: 'chains-reading-en-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/chains-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ChainsReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CouplesReadingEn/:exerciseId?/play',
        name: 'couples-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CouplesReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CouplesReadingEn/:exerciseId?/play',
        name: 'couples-reading-en-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/couples-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CouplesReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ScannerReadingEn/:exerciseId?/play',
        name: 'scanner-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/scanner/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Scanner',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/SchulteReadingEn/:exerciseId?/play',
        name: 'schulte-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/schulte/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Schulte',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/LettersFieldReadingEn/:exerciseId?/play',
        name: 'letters-field-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/letters-field/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'LettersField',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsFieldReadingEn/:exerciseId?/play',
        name: 'words-field-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/words-field-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsFieldReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/WordsFieldReadingEnWithTime/:exerciseId?/play',
        name: 'words-field-reading-en-with-time:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/words-field-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordsFieldReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/CatchWordReadingEn/:exerciseId?/play',
        name: 'catch-word-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/catch-word-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'CatchWordReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/VisionFieldReadingEn/:exerciseId?/play',
        name: 'vision-field-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vision-field-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VisionFieldReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ShutterReadingEn/:exerciseId?/play',
        name: 'shutter-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/shutter-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ShutterReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/ShutterRussianLanguage/:exerciseId?/play',
        name: 'shutter-russian-language:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/shutter-russian-language/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ShutterRussianLanguage',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/SynonymsReadingEn/:exerciseId?/play',
        name: 'synonyms-reading-en:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/synonyms-reading-en/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SynonymsReadingEn',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/TransferSyllables/:exerciseId?/play',
        name: 'transfer-syllables:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/transfer-syllables/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TransferSyllables',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/TransferSyllablesSchoolPreparing/:exerciseId?/play',
        name: 'transfer-syllables-school-preparing:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/transfer-syllables-school-preparing/Main.vue'
                ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TransferSyllablesSchoolPreparing',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/VoicedAndDeafConsonants/:exerciseId?/play',
        name: 'voiced-and-deaf-consonants:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/voiced-and-deaf-consonants/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VoicedAndDeafConsonants',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/DivideItRight/:exerciseId?/play',
        name: 'divide-it-right:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/divide-it-right/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'DivideItRight',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/ChooseItRight/:exerciseId?/play',
        name: 'choose-it-right:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/choose-it-right/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ChooseItRight',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/DivideUnstressedVowels/:exerciseId?/play',
        name: 'divide-unstressed-vowels:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/divide-unstressed-vowels/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'DivideUnstressedVowels',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/WordStructure/:exerciseId?/play',
        name: 'word-structure:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/word-structure/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordStructure',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/SentenceParsing/:exerciseId?/play',
        name: 'sentence-parsing:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/sentence-parsing/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SentenceParsing',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/VocabularyWordsRus/:exerciseId?/play',
        name: 'vocabulary-words-rus:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vocabulary-words-rus/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VocabularyWordsRus',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/WordDrum/:exerciseId?/play',
        name: 'word-drum:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/word-drum/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'WordDrum',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/VocabularyMemoRus/:exerciseId?/play',
        name: 'vocabulary-memo-rus:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/vocabulary-memo-rus/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VocabularyMemoRus',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/PartsOfSpeech/:exerciseId?/play',
        name: 'parts-of-speech:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/parts-of-speech/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'PartsOfSpeech',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/ParsingSentencePartsSpeech/:exerciseId?/play',
        name: 'parsing-sentence-parts-speech:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/parsing-sentence-parts-speech/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ParsingSentencePartsSpeech',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/GenericWords/:exerciseId?/play',
        name: 'generic-words:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/generic-words/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'GenericWords',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/VerbTenses/:exerciseId?/play',
        name: 'verb-tenses:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/verb-tenses/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'VerbTenses',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/SortOneMany/:exerciseId?/play',
        name: 'sort-one-many:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/sort-one-many/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SortOneMany',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/PunctuationMarks/:exerciseId?/play',
        name: 'punctuation-marks:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/punctuation-marks/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'PunctuationMarks',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/HardSoftConsonants/:exerciseId?/play',
        name: 'hard-soft-consonants:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/hard-soft-consonants/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'HardSoftConsonants',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/HardSoftConsonantsSchoolPreparing/:exerciseId?/play',
        name: 'hard-soft-consonants-school-preparing:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/hard-soft-consonants-school-preparing/Main.vue'
                ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'HardSoftConsonantsSchoolPreparing',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/Orthograph/:exerciseId?/play',
        name: 'orthograph:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/orthograph/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Orthograph',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/TranscriptionInWord/:exerciseId?/play',
        name: 'transcription-in-word:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/transcription-in-word/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'TranscriptionInWord',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/Alphabet/:exerciseId?/play',
        name: 'alphabet:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/alphabet/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'Alphabet',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/ConnectThePuzzles/:exerciseId?/play',
        name: 'connect-the-puzzles:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/connect-the-puzzles/Main.vue'
            ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'ConnectThePuzzles',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
                sameSettingsAreActive: $route.params.sameSettingsAreActive,
            };
        },
    },
    {
        path: 'trainer/games/SynonymsRussianLanguage/:exerciseId?/play',
        name: 'synonyms-russian-language:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/synonyms-russian-language/Main.vue'
                ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'SynonymsRussianLanguage',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
    {
        path: 'trainer/games/AntonymsRussianLanguage/:exerciseId?/play',
        name: 'antonyms-russian-language:start',
        component: () =>
            import(
                /* webpackPrefetch: true */ /* webpackChunkName: "games" */ '../../components/trainer/games/antonyms-russian-language/Main.vue'
                ),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props($route) {
            return {
                type: 'AntonymsRussianLanguage',
                exerciseId: $route.params.exerciseId,
                homeworkId: $route.params.homeworkId,
            };
        },
    },
];
